(() => {
  if (window.__TMP_2PLUS1_SELECTION_STATE__) return;
  window.__TMP_2PLUS1_SELECTION_STATE__ = true;

  const ROOT = '[data-tmp-bundle-root]';

  const getCardData = (root, variantId) => {
    const id = String(variantId || '');
    const card = Array.from(root.querySelectorAll('.tmp-meller-card')).find((item) => item.dataset.variantId === id);
    if (!card) return { variantId: id, name: 'SELECTED PAIR', color: '', image: '' };
    const info = card.querySelector('.tmp-meller-card__info');
    const name = info?.querySelector('strong')?.textContent?.trim() || 'SELECTED PAIR';
    const color = Array.from(info?.querySelectorAll(':scope > span') || []).find((item) => !item.classList.contains('tmp-meller-card__price'))?.textContent?.trim() || '';
    const image = card.querySelector('.tmp-meller-card__image img')?.currentSrc || card.querySelector('.tmp-meller-card__image img')?.src || '';
    return { variantId: id, name, color, image };
  };

  const createChip = (selection, label) => {
    const chip = document.createElement('div');
    chip.className = 'tmp-meller-selected-chip';

    const imageWrap = document.createElement('div');
    imageWrap.className = 'tmp-meller-selected-chip__image';
    if (selection.image) {
      const img = document.createElement('img');
      img.src = selection.image;
      img.alt = selection.name || label;
      img.loading = 'eager';
      img.decoding = 'async';
      imageWrap.appendChild(img);
    }

    const copy = document.createElement('div');
    copy.className = 'tmp-meller-selected-chip__copy';

    const eyebrow = document.createElement('span');
    eyebrow.className = 'tmp-meller-selected-chip__label';
    eyebrow.textContent = label;

    const name = document.createElement('strong');
    name.textContent = selection.name || 'SELECTED PAIR';

    const color = document.createElement('span');
    color.className = 'tmp-meller-selected-chip__color';
    color.textContent = selection.color || '';

    const status = document.createElement('span');
    status.className = 'tmp-meller-selected-chip__status';
    status.textContent = 'SELECTED ✓';

    copy.append(eyebrow, name, color, status);
    chip.append(imageWrap, copy);
    return chip;
  };

  const mount = (root) => {
    if (!root || root.dataset.tmpSelectionStateMounted === 'true') return;
    root.dataset.tmpSelectionStateMounted = 'true';

    const stageHead = root.querySelector('.tmp-meller-offer__stage-head');
    if (!stageHead) return;

    const strip = document.createElement('div');
    strip.className = 'tmp-meller-selected-strip';
    strip.setAttribute('aria-label', 'Your selected shades');
    strip.hidden = true;
    stageHead.after(strip);

    const state = { second: null, free: null };

    const render = () => {
      strip.replaceChildren();
      if (!state.second && !state.free) {
        strip.hidden = true;
        return;
      }
      strip.hidden = false;
      if (state.second) strip.appendChild(createChip(state.second, '2ND PAIR'));
      if (state.free) strip.appendChild(createChip(state.free, 'FREE PAIR'));
    };

    root.addEventListener('tmp:second_pair_selected', (event) => {
      state.second = getCardData(root, event.detail?.variantId);
      state.free = null;
      render();
    });

    root.addEventListener('tmp:free_pair_selected', (event) => {
      state.free = getCardData(root, event.detail?.variantId);
      render();
    });

    root.querySelector('[data-change-second]')?.addEventListener('click', () => {
      state.second = null;
      state.free = null;
      render();
    });

    const cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer) {
      const syncCartDrawer = () => {
        const open = cartDrawer.hasAttribute('active') || cartDrawer.hasAttribute('open') || cartDrawer.getAttribute('aria-hidden') === 'false';
        document.body.classList.toggle('tmp-cart-drawer-open', open);
      };
      syncCartDrawer();
      new MutationObserver(syncCartDrawer).observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['active', 'open', 'aria-hidden']
      });
    }
  };

  const init = (scope = document) => scope.querySelectorAll(ROOT).forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
